import React from "react";
import styled from "styled-components";
import { Flex } from "grid-styled";
import { withRouter } from "react-router-dom";
import StatusLabel from "../StatusLabel";
import H1 from "../Heading";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverContentItem
} from "../Popover";
import IconLink from "../IconLink";
import { DROPDOWN } from "../../icons";

class ServiceSwitcher extends React.Component {
  handleSelection = (serviceId, e) => {
    const { history, match } = this.props;
    const newUrl = match.url.replace(/\/\d+\/?$/, `/${serviceId}`);
    history.push(newUrl);
  };

  renderServices() {
    const sortedServices = this.props.services.slice().sort(function(a, b) {
      return parseInt(b.id, 10) - parseInt(a.id, 10);
    });
    let ServiceList = sortedServices.map(service => (
      <PopoverContentItem key={`service-${service.id}`} value={service.id}>
        <Flex justify="space-between">
          <div>{service.serviceType}</div>
          <StatusLabel status={service.status} style={{ marginLeft: 20 }} />
        </Flex>
      </PopoverContentItem>
    ));
    ServiceList.push(
      <PopoverContentItem key="service-new" value="new">
        Request a new service
      </PopoverContentItem>
    );
    return ServiceList;
  }

  render() {
    const { match, services, className } = this.props;

    const currentService =
      match.params.serviceId &&
      services.find(service => service.id === match.params.serviceId);

    return (
      <div className={className}>
        <H1>{currentService ? currentService.serviceType : "No services"}</H1>
        <Popover onSelection={this.handleSelection}>
          <PopoverTrigger
            aria-label="Available services"
            style={{ borderRadius: "50%", marginLeft: "12px" }}
          >
            <IconLink icon={DROPDOWN} style={{ display: "block" }} />
          </PopoverTrigger>
          <PopoverContent attachment="left">
            {this.renderServices()}
          </PopoverContent>
        </Popover>
      </div>
    );
  }
}

const StyledServiceSwitcher = styled(ServiceSwitcher)`
  position: relative;
  display: flex;
  align-items: center;
  z-index: 10;
`;

export default withRouter(StyledServiceSwitcher);



// WEBPACK FOOTER //
// ./src/components/services/ServiceSwitcher.js